import { ContractGroupType, ContractStatus } from '../../mdqx-graphql-types';

export class ContractGroupTypeEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(contractGroupTypeType: ContractGroupType | null) {
        if (
            contractGroupTypeType &&
            contractGroupTypeType.id != null &&
            contractGroupTypeType.name != null
        ) {
            this.Id = contractGroupTypeType.id;
            this.Name = contractGroupTypeType.name;
        } else {
            console.error('received broken ContractGroupTypeType', contractGroupTypeType);
            throw Error();
        }
    }
}
